import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import $ from 'jquery';
import '../css/TermsOfUsage.css';

import { RequestAjaxClass, TariffProductsModel, ClientModel, MultimediaTextModel } from 'models-lib';
import { ExtendedButton, MessageBox } from 'component-lib';

var moment = require('moment');
moment().format();

class TermsOfUsage  extends Component {

    constructor(props){

        super(props);
        this.state = {};
        this.state.me = this;
        this.state.AdultsTickets = [];
        this.state.StudentsTickets = [];

        this.ApplicationUrl = Vas.ApplicationUrl;
        this.ApiKey = Vas.ApiKey;
        this.ApiUrl = Vas.ApiUrl;
        this.UseMMTextsForTermsOfUsage = Vas.UseMMTextsForTermsOfUsage;

        // eslint-disable-next-line no-unused-expressions
        this.Request = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        // eslint-disable-next-line no-unused-expressions
        this.Request2 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);
        // eslint-disable-next-line no-unused-expressions
        this.Request3 = new RequestAjaxClass((error)=>{this.props.ErrorHandling ? this.props.ErrorHandling(error) : '';},null);

        this.ClientModel = new ClientModel([this],null,this.Request);
        
        this.TariffProductsModel =  new TariffProductsModel([this],null,this.Request);

        this.MultimediaTextModel = new MultimediaTextModel([this],null,this.Request2);

        this.TariffProducts = [];
        this.AboCenterArray = [];

        this.Request.setAuth(false);
        this.Request.setApiKey(this.ApiKey);
        this.Request.setApiUrl(this.ApiUrl);
        this.Request.setErrorHandler(()=>{
        $("#LoadingIconPopUp").removeClass().addClass('hide');
        });

        this.Request2.setAuth(false);
        this.Request2.setApiKey(this.ApiKey);
        this.Request2.setApiUrl(this.ApiUrl);
        this.Request2.setErrorHandler(()=>{
        $("#LoadingIconPopUp").removeClass().addClass('hide');
        });
        
    }

    componentDidMount(){
        this.ClientModel.GetClients();
        this.LogoClick();
        this.FontSizeClick();
        localStorage.removeItem('SelectedMotiv');
    }

    componentDidUpdate(){
        this.LogoClick();
        this.FontSizeClick();
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Clients"){
                this.AboCenterArray = me.ClientModel.Clients;
                if(this.AboCenterArray.length === 1 ){

                    let curContractStart = moment();
                    
                    this.TariffProductsModel.GetTickets(this.AboCenterArray[0].Id,
                        moment([curContractStart.year(),curContractStart.month(),curContractStart.date()]).format("YYYY-MM-DD T 00:00:00") );
                }
            }
            else if(observer === "Tickets"){
                let tickets = me.TariffProductsModel.ProductList;
                let erwachsene = [];
                let adults = [];
                let students = [];
                let fakeTicketChipCard = '';
                let fakeTicketSmartphone = '';
                let FilteredProductIdents = ("01-96-02;01-99-02;01-991-02;01-992-02;01-993-02").split(';');

                for(let i = 0 ; i < tickets.length; i++ ){

                    let productFiltered = false;

                    for(let j = 0; j < FilteredProductIdents.length; j++){
                        if(tickets[i].TicketIdent === FilteredProductIdents[j]){
                            if(tickets[i].TicketIdent === "01-991-02")
                            {
                                localStorage.setItem("Motiv1", JSON.stringify([tickets[i],null,null]));
                                fakeTicketChipCard = tickets[i];
                                fakeTicketChipCard.TicketIdent = "01-991-02;01-992-02;01-993-02";
                                fakeTicketChipCard.TicketName = "Deutschlandticket Chipkarte";
                                fakeTicketChipCard.IdTicket = "FakeTicketChipCard";
                            } else if(tickets[i].TicketIdent === "01-992-02")
                            {
                                localStorage.setItem("Motiv2", JSON.stringify([tickets[i],null,null]));
                                fakeTicketSmartphone = tickets[i];
                                fakeTicketSmartphone.TicketIdent = "01-991-02;01-992-02;01-993-02";
                                fakeTicketSmartphone.TicketName = "Deutschlandticket über Smartphone-App";
                                fakeTicketSmartphone.IdTicket = "FakeTicketSmartphone";
                            } else if(tickets[i].TicketIdent === "01-993-02")
                            {
                                localStorage.setItem("Motiv3", JSON.stringify([tickets[i],null,null]));
                            }
                            productFiltered = true;
                            break;
                        }
                    }

                    if(!productFiltered){
                    
                        if(tickets[i].TicketName === "Abo-Monatskarte Schüler/Azubi (Schulj.)"){
                            let inserted = false;
                            for(let j = 0; j <students.length; j++){
                                if(tickets[i].TicketName === students[j].TicketName){
                                    inserted = true;
                                    break;
                                }
                            }
                            if(inserted === false){
                                students.push(tickets[i]);
                            }
                        }
                        else if(tickets[i].TicketName === "Abo-Monatskarte (Einmalzahler)"){

                        }
                        else{
                            if(tickets[i].FlagSchuelerAbo === true){
                                let inserted = false;
                                for(let j = 0; j <students.length; j++){
                                    if(tickets[i].TicketName === students[j].TicketName){
                                        inserted = true;
                                        break;
                                    }
                                }
                                if(inserted === false){
                                    students.push(tickets[i]);
                                }
                            }else{
                                let inserted = false;
                                for(let j = 0; j <erwachsene.length; j++){
                                    if(tickets[i].TicketName === erwachsene[j].TicketName){
                                        inserted = true;
                                        break;
                                    }
                                }
                                if(inserted === false){
                                    erwachsene.push(tickets[i]);
                                }
                            }
                        }
                    }
                }

                adults.push(fakeTicketChipCard);
                adults.push(fakeTicketSmartphone);

                erwachsene.forEach(element => {
                    adults.push(element);
                });

                
                me.setState({AdultsTickets:adults,StudentsTickets:students});
            }
            else if(observer === "MultimediaTextFromId"){
                let tickets = this.GetContent();
                
                for(let i = 0; i< tickets.length; i++){
                    if(tickets[i].Ticket === localStorage.getItem("SelecedTicketForMMText")){

                        let acc = document.getElementsByClassName("showPanel");

                        if(acc.length === 1){
                            let cur = me.MultimediaTextModel.MultimediaText;
                            let table = acc[0].children[1];           
                            for(let i = table.rows.length -1; i >= 0; i--){
                                table.deleteRow(i);
                            }
                            for(let i = 0 ; i< cur.length; i++){
                                let text = cur[i];
                                let textArr = text.split(" - ");
                                for(let j = 0; j <textArr.length; j++){
                                    let row = table.insertRow();
                                    let cell = row.insertCell();
            
                                    if(j === 0){
                                        cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-bottom:-15px;width:640px;"><li id="i-' + i + '">' +textArr[j].substring(2) +'</li></ul>';
                                    }else{
                                        cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-bottom:-15px;width:640px;"><li id="i-' + i + '">' +textArr[j] +'</li></ul>';
                                    }
                                }
                            }

                            let row = table.insertRow();
                            let cell = row.insertCell();
                            var kontrastNumber = localStorage.getItem('Kontrast');

                                if(kontrastNumber == "true"){
                                    cell.innerHTML = '<ol style="list-style-type:none;list-style-position:outside; margin-top: 34px;"><li>' + 
                                    "<img id=" + "'ticketPriceInfo_" + tickets[i].Datei + "' style='width:680px;margin-left:-67px;'" + " src="+ document.location.origin + "/images/tariff/" + tickets[i].Datei +"Dark.png"+">"+
                                    "<div><a href=" + document.location.origin + "/images/tariff/" + tickets[i].Datei +"Dark.png" + " target='blank'> hier</<a></div>" +
                                '</li></ol>';
                                } else{
                                    cell.innerHTML = '<ol style="list-style-type:none;list-style-position:outside; margin-top: 34px;"><li>' + 
                                    "<img id=" + "'ticketPriceInfo_" + tickets[i].Datei +  "' style='width:680px;margin-left:-67px;'" + " src="+ document.location.origin + "/images/tariff/" + tickets[i].Datei +".png"+">"+
                                    "<div><a href=" + document.location.origin + "/images/tariff/" + tickets[i].Datei +".png" + " target='blank'> hier</<a></div>" +
                                '</li></ol>';
                                }   
                        }

                        break;
                    }
                }
            }
        });

        this.LogoClick();
        this.FontSizeClick();
    }

    GetContent(){


        return([
            {Ticket:"Abo-Monatskarte",Datei: "AboMonatskarteUebertragbar",Content:["Weitergabe an andere Personen möglich",
                "samstags, sonn- und feiertags Berechtigung der Nutzung von max. 5 Personen ohne Altersbegrenzung",
                "unentgeltliche Mitnahme eines Hundes",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                ]},
            {Ticket:"Abo-Monatskarte Schüler/Azubi (Schulj.)",Datei:"AboMonatskarteSchuelerSchuljahr",Content:["für Schüler und Auszubildende ",
                "ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "tarifzonenübergreifende Fahrten sind mit AnschlussTicket möglich",
                "befristete Vertragsdauer für das Schuljahr in Sachsen (keine Nutzung in den Sommerferien möglich)",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                    
                "<b>wichtiger Hinweis:</b><br/> Bei der Beantragung müssen aus statistischen Gründen die Einstiegshaltestelle (am Wohnort) und die Ausstiegshaltestelle (an der Bildungseinrichtung) angegeben werden. Die Wertmarke kann dennoch in der gesamten gewählten räumlichen Gültigkeit genutzt werden."
                ]},
            {Ticket:"9-Uhr-Abo-Monatskarte(nicht übertragbar)",Datei:"9UhrAboMonatskarte",Content:["personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "montags bis freitags von 09:00 bis 04:00 Uhr des Folgetages und samstags, sonn- und feiertags ganztägig gültig",
                "samstags, sonn- und feiertags Berechtigung der Nutzung von max. 5 Personen ohne Altersbegrenzung",
                "unentgeltliche Mitnahme eines Hundes",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden"
                ]},
            {Ticket:"9-Uhr-Abo-Monatskarte",Datei:"9UhrAboMonatskarteUebertragbar",Content:["Weitergabe an andere Personen möglich",
                "montags bis freitags von 09:00 bis 04:00 Uhr des Folgetages und samstags, sonn- und feiertags ganztägig gültig ",
                "samstags, sonn- und feiertags Berechtigung der Nutzung von max. 5 Personen ohne Altersbegrenzung",
                "unentgeltliche Mitnahme eines Hundes",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                ]},
            {Ticket:"Abo-Monatskarte (Einmalzahler)",Datei:"AboMonatskarte", Content: ["personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)"
                ,"samstags, sonn- und feiertags Berechtigung der Nutzung von max. 5 Personen ohne Altersbegrenzung"
                ,"unentgeltliche Mitnahme eines Hundes"
                ,"Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich"
                ,"tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich"
                ,"Mindestvertragsdauer vier Monate, danach monatlich kündbar"
                ,"Bezahlung per SEPA-Basis-Lastschriftverfahren"
                ,"Wertmarken kommen pünktlich und bequem per Post nach Hause"
                ,"Wertmarken müssen nicht entwertet werden"
                ]},
            {Ticket:"Abo-Monatskarte (nicht übertragbar)",Datei:"AboMonatskarte", Content: ["personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)"
                ,"samstags, sonn- und feiertags Berechtigung der Nutzung von max. 5 Personen ohne Altersbegrenzung"
                ,"unentgeltliche Mitnahme eines Hundes"
                ,"Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich"
                ,"tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich"
                ,"Mindestvertragsdauer vier Monate, danach monatlich kündbar"
                ,"Bezahlung per SEPA-Basis-Lastschriftverfahren"
                ,"Wertmarken kommen pünktlich und bequem per Post nach Hause"
                ,"Wertmarken müssen nicht entwertet werden"
                ]},
            {Ticket:"JungeLeuteTicket",Datei:"JungeLeute",Content:["für Personen vom 15. bis zum 26. Geburtstag",
            "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
            "gültig im gesamten VMS-Verbundraum",
            "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
            "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
            "Bezahlung per SEPA-Basis-Lastschriftverfahren",
            "Wertmarken kommen pünktlich und bequem per Post nach Hause",
            "Wertmarken müssen nicht entwertet werden",
            "keine Mitnahme weiterer Personen ",
            "keine unentgeltliche Beförderung eines Hundes"
                ]},
            {Ticket:"SeniorenTicket",Datei:"Senioren",Content:["für Personen ab dem 63. Geburtstag",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                ]},
            {Ticket:"Abo-Monatskarte Schüler/Azubi",Datei:"AboMonatskarteSchueler12Monate",Content:["für Schüler, Auszubildende und Studenten"
                ,"ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden"
                ,"personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)"
                ,"Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich"
                ,"tarifzonenübergreifende Fahrten sind mit AnschlussTicket bzw. im Rahmen der räumlichen Gültigkeit möglich"
                ,"Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung"
                ,"Bezahlung per SEPA-Basis-Lastschriftverfahren"
                ,"Wertmarken kommen pünktlich und bequem per Post nach Hause"
                ,"Wertmarken müssen nicht entwertet werden"
                ,"keine Mitnahme weiterer Personen"
                ,"keine unentgeltliche Beförderung eines Hundes"
                
                ,"<b>wichtige Hinweise:</b><br/> Bei der Beantragung müssen aus statistischen Gründen die Einstiegshaltestelle (am Wohnort) und die Ausstiegshaltestelle (an der Bildungseinrichtung) angegeben werden. Die Wertmarke kann dennoch in der gesamten gewählten räumlichen Gültigkeit genutzt werden.<br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung oder Kündigung vor, so wird das Ticket automatisch in ein Abonnement zum Normalfahrpreis der gewählten Preisstufe umgestellt."
                ]},
            {Ticket:"AzubiTicket Sachsen, Berufsschule außerhalb Sachsen",Datei:"AzubiSachsenBerufsschuleAußerhalb",Content:["für Auszubildende mit Ausbildungsbetrieb innerhalb des VMS-Gebietes und berufsbildender Schule außerhalb von Sachsen",
                "es muss ein Nachweis von der Berufsschule und des Ausbildungsbetriebs (mit der Angabe des Ausbildungsberufs) erbracht werden.",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig in den gewählten Verkehrsverbünden (VMS, MDV, VVO, VVV, ZVON)",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"AzubiTicket Sachsen, Freiwilligendienst",Datei:"AzubiSachsenFreiwilligendienst",Content:["für Dienstleistende im Bundesfreiwilligendienst, Jugendfreiwilligendienst und Freiwilligendienst der Generationen mit Einsatzstelle innerhalb des VMS-Gebietes",
                "es muss ein Nachweis von der Einsatzstelle des Freiwilligendienstes erbracht werden.",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig in den gewählten Verkehrsverbünden (VMS, MDV, VVO, VVV, ZVON)",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"AzubiTicket Sachsen",Datei:"AzubiSachsen",Content:["für Auszubildende mit berufsbildender Schule innerhalb des VMS-Gebietes",
                "es muss ein Berufsschulnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig in den gewählten Verkehrsverbünden (VMS, MDV, VVO, VVV, ZVON)",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"JungeLeuteTicket (Azubi)",Datei:"JungeLeuteSchueler",Content:["für Schüler und Berufsschüler vom 15. bis zum 26. Geburtstag ",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer vier Monate, danach monatlich kündbar",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen" ,
                "keine unentgeltliche Beförderung eines Hundes",
                "Angabe der besuchten Schule (allgemein- oder berufsbildend)"
            ]},
            {Ticket:"SchülerFreizeitTicket",Datei:"SchuelerFreizeit",Content:["für Schüler allgemeinbildender Schulen ",
                "ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig montags bis freitags ab 14:00 Uhr",
                "samstags, sonn- und feiertags sowie an einheitlich schulfreien Tagen im Freistaat Sachsen ganztägig gültig ",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                    
                "<b>wichtiger Hinweis:</b><br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"Schülerverbundkarte (Azubi)",Datei:"SchuelerverbundkarteAzubi",Content:["für Schüler berufsbildender Schulen",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Bei der Beantragung müssen aus statistischen Gründen die Einstiegshaltestelle (am Wohnort) und die Ausstiegshaltestelle (an der Bildungseinrichtung) angegeben werden. Die Wertmarke kann dennoch in der gesamten gewählten räumlichen Gültigkeit genutzt werden.<br/>Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung oder Kündigung vor, so wird das Ticket automatisch in ein Abonnement zum Normalfahrpreis der gewählten Preisstufe umgestellt."
            ]},
            {Ticket:"SchülerVerbundKarte",Datei:"Schuelerverbundkarte",Content:["für Schüler allgemeinbildender Schulen",
                "ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Bei der Beantragung müssen aus statistischen Gründen die Einstiegshaltestelle (am Wohnort) und die Ausstiegshaltestelle (an der Bildungseinrichtung) angegeben werden. Die Wertmarke kann dennoch in der gesamten gewählten räumlichen Gültigkeit genutzt werden.<br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung oder Kündigung vor, so wird das Ticket automatisch in ein Abonnement zum Normalfahrpreis der gewählten Preisstufe umgestellt."
            ]},
            {Ticket:"BildungsTicket",Datei:"Bildungsticket",Content:["für Schüler allgemeinbildender Schulen",
                "die Angabe der Schule und des Schulortes ist erforderlich",
                "ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Auf Grund einer statistischen Erhebung ist Ihrerseits bei der Beantragung des BildungsTickets die Angabe der Einstiegshaltestelle am Wohnort und die der Ausstiegshaltestelle an der Bildungseinrichtung zwingend erforderlich, das Ticket ist im gesamten Verkehrsverbund gültig.<br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"BildungsTicket (Azubi)",Datei:"Bildungsticket",Content:["für Schüler berufsbildender Schulen, die sich nicht in einer dualen Ausbildung befinden",
                "die Angabe der Schule und des Schulortes ist erforderlich",
                "ab dem 15.Geburtstag muss ein Ermäßigungsnachweis erbracht werden",
                "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
                "gültig im gesamten VMS-Verbundraum",
                "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
                "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
                "Bezahlung per SEPA-Basis-Lastschriftverfahren",
                "Wertmarken kommen pünktlich und bequem per Post nach Hause",
                "Wertmarken müssen nicht entwertet werden",
                "keine Mitnahme weiterer Personen ",
                "keine unentgeltliche Beförderung eines Hundes",
                
                "<b>wichtiger Hinweis:</b><br/> Auf Grund einer statistischen Erhebung ist Ihrerseits bei der Beantragung des BildungsTickets die Angabe der Einstiegshaltestelle am Wohnort und die der Ausstiegshaltestelle an der Bildungseinrichtung zwingend erforderlich, das Ticket ist im gesamten Verkehrsverbund gültig.<br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},
            {Ticket:"BildungsTicket Freiwilligendienst",Datei:"Bildungsticket",Content:["für Dienstleistende im Bundesfreiwilligendienst, Jugendfreiwilligendienst und Freiwilligendienst der Generationen mit Einsatzstelle innerhalb des VMS-Gebietes",
            "es muss ein Nachweis von der Einsatzstelle des Freiwilligendienstes erbracht werden",
            "personengebunden, nur gültig bei gleichzeitigem Mitführen der persönlichen Kundenkarte (erhalten Sie zusammen mit Ihren Abo-Wertmarken)",
            "gültig im gesamten VMS-Verbundraum",
            "Fahrtunterbrechung und beliebiges Umsteigen im Rahmen der zeitlichen und räumlichen Gültigkeit möglich",
            "Mindestvertragsdauer zwölf Monate, max. jedoch bis zum Ablauf der Ermäßigungsberechtigung",
            "Bezahlung per SEPA-Basis-Lastschriftverfahren",
            "Wertmarken kommen pünktlich und bequem per Post nach Hause",
            "Wertmarken müssen nicht entwertet werden",
            "keine Mitnahme weiterer Personen ",
            "keine unentgeltliche Beförderung eines Hundes",
            
            "<b>wichtiger Hinweis:</b><br/> Auf Grund einer statistischen Erhebung ist Ihrerseits bei der Beantragung des BildungsTickets die Angabe der Einstiegshaltestelle am Wohnort und die der Ausstiegshaltestelle an der Bildungseinrichtung zwingend erforderlich, das Ticket ist im gesamten Verkehrsverbund gültig.<br/> Liegt nicht rechtzeitig vor Ablauf der Ermäßigungsberechtigung, d.h.  bis zum 10. Kalendertag des Vormonats, eine neue Ermäßigungsberechtigung vor, endet das Abonnement automatisch."
            ]},

            {Ticket:"Deutschlandticket Chipkarte",Datei: "AlleMotive",Content:[
            ]},
            {Ticket:"Deutschlandticket über Smartphone-App",Datei: "KeineMotive" ,Content:[
            ]}
        ])
    }
    openTariffing(ticket){
        
        var tariff = JSON.stringify([ticket,null,null]);

        if(ticket.TicketName == "Deutschlandticket Chipkarte"){
            if(document.getElementById("Motiv1").checked){
                tariff = localStorage.getItem("Motiv1");
                localStorage.setItem('SelectedMotiv', 1);
            } else if(document.getElementById("Motiv2").checked){
                tariff = localStorage.getItem("Motiv2");
                localStorage.setItem('SelectedMotiv', 2);
            } else if(document.getElementById("Motiv3").checked){
                tariff = localStorage.getItem("Motiv3");
                localStorage.setItem('SelectedMotiv', 3);
            } else {
                tariff = "";

                ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Labels["GermanTicketNoMitivSelected"]} 
                    Title={Vas.Resources.Titles["Note"]} 
                    />
                      ,document.getElementById('messageContainer'));
            }
        }

        if(tariff !== "") {
            localStorage.setItem('Tariff', tariff);
            localStorage.setItem('ChangeProductsFromTermsOfUsage', 'true');
            Vas.GetView('Tariffing', null, false);
        }
    }
    //#endregion

    ShowText(ticketName){
        let tickets = this.GetContent();
        for(let i = 0; i< tickets.length; i++){
            if(tickets[i].Ticket === ticketName){
                localStorage.setItem('TicketName', tickets[i].Datei);

                let acc = document.getElementsByClassName("showPanel");

                if(acc.length === 1){
                    let cur = tickets[i].Content;

                    //Der Index von .children wurde hier von 0 auf 1 gesetzt, da vor der Tabelle ein div eingefügt wurde
                    //siehe Methode GetTickets(tickets)
                    let table = acc[0].children[1];
                    
                    for(let i = table.rows.length -1; i >= 0; i--){
                        table.deleteRow(i);
                    }
                    for(let i = 0 ; i< cur.length; i++){
                        let text = cur[i];
                        let textArr = text.split(" - ");
                        let connector = "";
                        for(let j = 0; j <textArr.length; j++){
                            let row = table.insertRow();
                            let cell = row.insertCell();
    
                            if(j === 0){
                                if(textArr[j].charAt(0) === "-"){
                                    connector = "- ";
                                }
                                cell.innerHTML = '<ul style="list-style-type:unset;list-style-position:outside;margin-top:0px;margin-bottom:-15px;width:640px;"><li id="i-' + i + '">' +textArr[j] +'</li></ul>';
                            }else{
                                cell.innerHTML = connector + textArr[j];
                            }
                        }
                    }

                    let row = table.insertRow();
                    let cell = row.insertCell();
                    var kontrastNumber = localStorage.getItem('Kontrast');

                    if(tickets[i].Datei === "AlleMotive")
                    {
                            cell.innerHTML = '<ol id="chooseMotiv" style="list-style-type:none;list-style-position:outside;">'+ Vas.Resources.Labels["GermanTicketChipCardHint"] +
                            '<li>' + 
                                "</br><div id='chooseMotiv1' style='margin-left: 150px;margin-right: 150px;'>Motiv 1</div></br>" +
                                "<input type='radio' id='Motiv1' name='motiv1' value='30' style='margin-right: 40px;position: relative;top: -80px;'>" +
                                "<img id=" + "'ticketPriceInfo_Motiv1' style='width:226.67px;margin-left:-16.75px;'" + " src="+ document.location.origin + "/images/tariff/Motiv1.png"+"></br>"+
                            '</li>' +
                            '<li>' + 
                                "</br><div id='chooseMotiv2' style='margin-left: 150px;margin-right: 150px;'>Motiv 2</div></br>" +
                                "<input type='radio' id='Motiv2' name='motiv1' value='30' style='margin-right: 40px;position: relative;top: -80px;'>" +
                                "<img id=" + "'ticketPriceInfo_Motiv2' style='width:226.67px;margin-left:-16.75px;'" + " src="+ document.location.origin + "/images/tariff/Motiv2.png"+"></br>"+
                            '</li>' +
                            '<li>' + 
                                "</br><div id='chooseMotiv3' style='margin-left: 150px;margin-right: 150px;'>Motiv 3</div></br>" +
                                "<input type='radio' id='Motiv3' name='motiv1' value='30' style='margin-right: 40px;position: relative;top: -80px;'>" +
                                "<img id=" + "'ticketPriceInfo_Motiv3' style='width:226.67px;margin-left:-16.75px;'" + " src="+ document.location.origin + "/images/tariff/Motiv3.png"+"></br>"+
                            '</li>' +
                            '</ol>';
                    } else if (tickets[i].Datei === "KeineMotive") {
                        cell.innerHTML = '<ol id="noMotiv" style="list-style-type:none;list-style-position:outside;"><b>' + Vas.Resources.Labels["GermanTicketSmartphoneAppHint1"] + '</b>'+
                            '<li>' + 
                                "</br><div id='noMotivHint'>" + Vas.Resources.Labels["GermanTicketSmartphoneAppHint2"] + "</div></br>" +
                                "<a id='noMotivLink' style='display:block' href='https://www.cvag.de/deutschlandticket' target='blank'>" + Vas.Resources.Labels["GermanTicketButtonText"] + "</<a>" +
                            '</li>' +
                            '</ol>';

                    } else {
                        if(kontrastNumber == "true"){
                            cell.innerHTML = '<ol style="list-style-type:none;list-style-position:outside; margin-top: 34px;"><li>' + 
                            "<img id=" + "'ticketPriceInfo_" + tickets[i].Datei + "' style='width:680px;margin-left:-67px;'" + " src="+ document.location.origin + "/images/tariff/" + tickets[i].Datei +"Dark.png"+">"+
                            "<div><a href=" + document.location.origin + "/images/tariff/" + tickets[i].Datei +"Dark.png" + " target='blank'> hier</<a></div>" +
                        '</li></ol>';
                        } else{
                            cell.innerHTML = '<ol style="list-style-type:none;list-style-position:outside; margin-top: 34px;"><li>' + 
                            "<img id=" + "'ticketPriceInfo_" + tickets[i].Datei +  "' style='width:680px;margin-left:-67px;'" + " src="+ document.location.origin + "/images/tariff/" + tickets[i].Datei +".png"+">"+
                            "<div><a href=" + document.location.origin + "/images/tariff/" + tickets[i].Datei +".png" + " target='blank'> hier</<a></div>" +
                        '</li></ol>';
                        }  
                    } 
                }
            }
        }

        this.FontSizeClick();
    }

    accordeonClick(ticket){

        let classList = document.getElementById(ticket.IdTicket).classList;

        if(classList.length == 2){

            let acc = document.getElementsByClassName("showPanel");
        
            for(let i = 0; i<acc.length; i++){
            acc[i].classList.remove("showPanel");
            }

            acc = document.getElementsByClassName("activeTerms");
            
            for(let i = 0; i<acc.length; i++){
            acc[i].classList.remove("activeTerms");
            }

        } else if (classList.length == 1){

            let acc = document.getElementsByClassName("showPanel");
        
            for(let i = 0; i<acc.length; i++){
            acc[i].classList.remove("showPanel");
            }

            acc = document.getElementsByClassName("activeTerms");
            
            for(let i = 0; i<acc.length; i++){
            acc[i].classList.remove("activeTerms");
            }

            document.getElementById(ticket.IdTicket).classList.add('showPanel');
            document.getElementById(ticket.IdTicket).parentElement.children[0].classList.add('activeTerms');

            if(this.UseMMTextsForTermsOfUsage && ticket.TicketName.indexOf('Deutschlandticket') == -1){
                localStorage.setItem("SelecedTicketForMMText", ticket.TicketName);
                this.MultimediaTextModel.GetMultimediaTextFromTicketId(ticket.IdTicket);
            }

        }
      
        if(ticket.TicketName.indexOf('Deutschlandticket') == 0 || !this.UseMMTextsForTermsOfUsage){
            this.ShowText(ticket.TicketName);
        }

        var kontrastNumber = localStorage.getItem('Kontrast');
    
        if(kontrastNumber == "true"){

            $('.accordion').attr('style', 'color: black; background-color: #ffffff;');
            $('.activeTerms').attr('style', 'color: white; background-color: #1d5c87;');
            $('.showPanel').attr('style', 'border: 1px solid #1d5c87;');
        }
    }

    GetAdultTickets(){

        return this.GetTickets(this.state.AdultsTickets);
    }

    GetStudentsTickets(){

        return this.GetTickets(this.state.StudentsTickets);
    }

    GetTickets(tickets){

        //Hier das Array definieren
        let documentDownloadProductsArray = ["Abo-Monatskarte Schüler/Azubi (Schulj.)", 
                                             "Abo-Monatskarte Schüler/Azubi", 
                                             "AzubiTicket Sachsen, Berufsschule außerhalb Sachsen", 
                                             "AzubiTicket Sachsen, Freiwilligendienst", 
                                             "AzubiTicket Sachsen",
                                             "SchülerFreizeitTicket", 
                                             "Schülerverbundkarte (Azubi)", 
                                             "SchülerVerbundKarte",
                                             "BildungsTicket",
                                             "BildungsTicket (Azubi)"];

        return (<table>
            <tbody>
                {tickets.map(t=>{

                    let downloadButton = (<div></div>);

                    if(documentDownloadProductsArray.indexOf(t.TicketName) > 0){
                        downloadButton = (<div id={"DownloadButton"} style={{ float: 'right', marginBottom: '15px' }}>
                            <ExtendedButton
                              Id={"DownloadDocument"}
                              Usable={true}
                              Text={ Vas.Resources.Labels["ReductionDocumentDownload"] }
                              Width={170}
                              Float={"left"}
                              OnClick={() => { window.open(Vas.ApplicationUrl+"/ErmäßigungABO.pdf") }} />
                            </div>);
                    }

                    let extendedButton = (<ExtendedButton
                        Id={"bto" + t.IdTicket}
                        Usable={true} 
                        Text={Vas.Resources.Labels["Apply"]}
                        OnClick={()=>{
                            this.openTariffing(t);
                        }}
                        Width={120}
                        Float={'right'}>
                    </ExtendedButton>);

                    if(t.TicketName === "Deutschlandticket über Smartphone-App"){
                        extendedButton = (<div></div>);
                    }

                    return( 
                        <tr>
                            <td className={"accordionTableRow"}>
                                <button className="accordion" onClick={()=>{this.accordeonClick(t)}}>{t.TicketName}</button>
                                <div className="panelTerms" id={t.IdTicket}>
                                { downloadButton }           
                                <table></table>
                               <table className={'buttonTable'}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div style={{ marginRight: '-148px' }}>
                                                    { extendedButton }
                                                </div>
                                            </td>        
                                        </tr>
                                    </tbody>   
                                </table> 
                            </div>
                                
                            </td>
                        </tr>
                    ) 
                })}
            </tbody>
        </table>);


    }

    GetView(nameOfView){
        this.DeselectTabs();
        
        switch (nameOfView){
            case "Adults":
                this.SelectTab("AdultsTabLink");
                this.setState({ CurrentView: "Adults" });
                break;
            case "Students":
                this.SelectTab("StudentsTabLink");
                this.setState({ CurrentView: "Students" });
                break;
            default:
                this.SelectTab("AdultsTabLink");
                this.setState({ CurrentView: "Adults" });
        }
    }

    SelectTab(id){
        $("#"+id).removeClass().addClass("activeTabTerms");
    }

    DeselectTabs()
    {
        $("#AdultsTabLink").removeClass().addClass("tabTerms");
        $("#StudentsTabLink").removeClass().addClass("tabTerms");       
    }

    LogoClick(){

        var kontrastNumber = localStorage.getItem('Kontrast');
    
        if(kontrastNumber == "true"){
          $('.termsofusageform').attr('style', 'border: 1px solid #1d5c87;');

          $('#StudentsTabLink').mousedown(function() {
            $(this).attr('style', 'color: white; cursor: pointer; background-color: #00375b;');
            $('#AdultsTabLink').attr('style', 'color: white; cursor: pointer; background-color: #1d5c87;');
          });

          $('#AdultsTabLink').mousedown(function() {
            $(this).attr('style', 'color: white; cursor: pointer; background-color: #00375b;');
            $('#StudentsTabLink').attr('style', 'color: white; cursor: pointer; background-color: #1d5c87;');
          });

          $('.accordion').mouseenter(function() {
            $(this).attr('style', 'color: white; background-color: #1d5c87;');

          }).mouseleave(function() {
            $(this).attr('style', 'color: black; background-color: #ffffff;');
            $('.activeTerms').attr('style', 'color: white; background-color: #1d5c87;');
          });

          $('.showPanel').attr('style', 'border: 1px solid #1d5c87;');

          $('.termsofusageform .extendedButton').attr('style', 'background-color: #1d5c87; width: 120px; float: right;');

          $('.termsofusageform .extendedButton').mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 120px; float: right;');

          }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 120px; float: right;');
          });

          $('.accordion').attr('style', 'color: black; background-color: #ffffff;');
        $('.activeTerms').attr('style', 'color: white; background-color: #1d5c87;');
        $('.showPanel').attr('style', 'border: 1px solid #1d5c87;');
        }
    }

    FontSizeClick(){
        var schriftgröße = localStorage.getItem('Schriftgröße');
    
        //Schriftgröße bei Klick in 2er Schritten erhöhen
        //$('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");
    //btoFakeTicketChipCard
          if(schriftgröße != null){
                switch(schriftgröße){
                  case "0":
                    $("#DownloadDocument").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".accordion").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $("#chooseMotiv").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_18").addClass("Schriftgröße_19"); 
                    
                    $(".extendedButton ").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $("#noMotiv").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#noMotivHint").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#noMotivLink").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                  break;
                  case "1":
                    $("#DownloadDocument").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $(".accordion").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");    
                    
                    $("#chooseMotiv").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                    $(".extendedButton ").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                    $("#noMotiv").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $("#noMotivHint").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");  
                    $("#noMotivLink").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                  break;
                  case "2":
                    $("#DownloadDocument").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $(".accordion").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");   

                    $("#chooseMotiv").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                    $(".extendedButton ").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                    $("#noMotiv").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");  
                    $("#noMotivHint").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");  
                    $("#noMotivLink").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                  break;
                  case "3":  
                    $("#DownloadDocument").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $(".accordion").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                    $("#chooseMotiv").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                    $(".extendedButton ").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                    $("#noMotiv").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");  
                    $("#noMotivHint").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");  
                    $("#noMotivLink").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                  break;
                  case "4":
                    $("#DownloadDocument").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".accordion").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                    $("#chooseMotiv").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                    $(".extendedButton ").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                    $("#noMotiv").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");  
                    $("#noMotivHint").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");  
                    $("#noMotivLink").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                  break;
                  case "5":
                    $("#DownloadDocument").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".accordion").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                    $("#chooseMotiv").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                    $(".extendedButton ").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                    $("#noMotiv").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");  
                    $("#noMotivHint").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");  
                    $("#noMotivLink").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                  break;
                }
          }
      };


    render()
    {

        let contentAdults = "";
        let contentStudents = "";
        switch (this.state.CurrentView)
        {
            case "Adults":
                contentAdults = this.GetAdultTickets();
                break;
           case "Students":
                contentStudents = this.GetStudentsTickets();
                break;
            default: contentAdults = this.GetAdultTickets();
        }

        return(
            <div className={"termsofusageform"} >
            <div className="termsOfUsageCard">
                  <div className={"termsOfUsageCardLinks"}>
                    <table>
                      <tbody>
                        <tr>
                          <td
                            id={"AdultsTabLink"}
                            className={"activeTabTerms"}
                            onClick={()=>{ this.GetView("Adults");}} >{Vas.Resources.Labels["Adults"]}</td>
                        </tr>
                        <tr>
                          <td
                            id={"StudentsTabLink"}
                            className={"tabTerms"}
                            onClick={()=>{ this.GetView("Students");}} >{Vas.Resources.Labels["Students"]}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div
                    id={"tabContent"}>{contentAdults}{contentStudents}</div>
            </div>
          </div>
        );

    }
}
export default TermsOfUsage;
